import React, { ReactNode, MouseEvent } from 'react';

// Material ui
import {
    Card,
    Grid,
    Collapse
} from '@material-ui/core';

// Styles
import './CardItems.scss';

interface Props {
    children?: ReactNode;
    actions?: {
        label: string;
        handler: () => void;
    }[];
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    variant?: 'outlined' | 'transparent' | 'normal';
    onHoverEffect?: boolean;
    onClick?: (_element: MouseEvent<HTMLDivElement>) => any;
    tooltip?: string;
    collapsed?: {
        opened: boolean;
        children: ReactNode;
    };
    direction?: 'row' | 'column';
    justify?: 'flex-start' | 'center' | 'space-between' | 'flex-end' | 'space-around';
    className?: string;
    disabled?: boolean;
}

const CardItem: React.FC<Props> = ({
    children,
    xs = 12,
    variant = 'normal',
    onClick,
    tooltip,
    onHoverEffect,
    collapsed,
    className,
    direction = 'row',
    justify = 'flex-start',
    disabled = false
}) => {

    return (
        <>
            <Grid
                item
                container
                xs={xs}
                className="ui-Card-item-container"
            >
                <Card
                    style={{
                        flexDirection: direction,
                        justifyContent: justify
                    }}
                    onClick={onClick}
                    data-text={tooltip ? tooltip : undefined}
                    className={`ui-Card-item-component${variant === 'outlined'
                        ? ' border-outlined'
                        : variant === 'transparent' ? ' transparent-card-item' : ''}${onHoverEffect
                        ? ' on-hover-effect'
                        : ''}${className ? ` ${className}` : ''}${disabled ? ' disabled' : ''}`}
                >
                    {children}
                    {collapsed && (
                        <Collapse
                            classes={{
                                container: 'ui-Card-collapsed-container'
                            }}
                            in={collapsed.opened}
                        >
                            {collapsed.children}
                        </Collapse>
                    )}
                </Card>
            </Grid>
        </>
    );
};

export default CardItem;